module.exports = __webpack_public_path__ + "img/empty.3afd7b49.svg";